
import {
  createWidgetMixin
} from 'vue-instantsearch'
import { connectInfiniteHits } from 'instantsearch.js/es/connectors';
  export default {
    mixins: [createWidgetMixin({ connector: connectInfiniteHits })],
    methods: {
      visibilityChanged(isVisible) {
        if (isVisible && !this.state.isLastPage) {
          this.state.showMore();
        }
      },
    },
  }
